import React from 'react';

const CarouselDetails = () => {
	return (
		<div style={{}}>
			<div
				id='carouselExampleIndicators'
				class='carousel slide'
				data-ride='carousel'>
				<ol class='carousel-indicators'>
					<li
						data-target='#carouselExampleIndicators'
						data-slide-to='0'
						class='active'></li>
					<li data-target='#carouselExampleIndicators' data-slide-to='1'></li>
					<li data-target='#carouselExampleIndicators' data-slide-to='2'></li>
				</ol>
				<div class='carousel-inner'>
					<div class='carousel-item active'>
						<img
							class='d-block w-100'
							src='https://images.template.net/wp-content/uploads/2022/05/Banner-Ideas.jpg'
							alt='First slide'
						/>
					</div>
					<div class='carousel-item'>
						<img
							class='d-block w-100'
							src='https://img.freepik.com/free-psd/realistic-business-banner-design-template_23-2149361044.jpg'
							alt='Second slide'
						/>
					</div>
					<div class='carousel-item'>
						<img
							class='d-block w-100'
							src='https://img.freepik.com/premium-vector/stylish-furniture-facebook-cover-page-design-sale-banner-design-template-premium-vector_560969-99.jpg?w=2000'
							alt='Third slide'
						/>
					</div>
				</div>
				<a
					class='carousel-control-prev'
					href='#carouselExampleIndicators'
					role='button'
					data-slide='prev'>
					<span class='carousel-control-prev-icon' aria-hidden='true'></span>
					<span class='sr-only'>Previous</span>
				</a>
				<a
					class='carousel-control-next'
					href='#carouselExampleIndicators'
					role='button'
					data-slide='next'>
					<span class='carousel-control-next-icon' aria-hidden='true'></span>
					<span class='sr-only'>Next</span>
				</a>
			</div>
		</div>
	);
};

export default CarouselDetails;
